import {
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_START,
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_SUCCESS,
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_FAIL,

} from "../../../constants";
import {
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getDevAndStrengthVisualization = createVisualizationFetchAction(FETCH_DEV_AND_STRENGTH_VISUALIZATION_URL, {
    START: FETCH_DEV_AND_STRENGTH_VISUALIZATION_START,
    SUCCESS: FETCH_DEV_AND_STRENGTH_VISUALIZATION_SUCCESS,
    FAIL: FETCH_DEV_AND_STRENGTH_VISUALIZATION_FAIL,
});

